(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 65399:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(54239);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ StyledFaqsHeader; },
/* harmony export */   "Ie": function() { return /* binding */ StyledWebFaqs; },
/* harmony export */   "s5": function() { return /* binding */ StyledFaqsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99655);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledFaqsSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFaqsHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledWebFaqs = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-73f69e31-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_200"));


/***/ }),

/***/ 29372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53307);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99655);
/* harmony import */ var _Faqs_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12109);




var Faqs = function(param) {
    var faqs = param.faqs, title = param.title, desc = param.desc, h3 = param.h3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs && faqs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsSection */ .s5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsHeader */ .$t, {
                    children: [
                        !h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                            editorial: true,
                            children: title
                        }),
                        h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                            editorial: true,
                            children: title
                        }),
                        desc && typeof desc === "object" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: desc
                        }),
                        typeof desc === "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: desc || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledWebFaqs */ .Ie, {
                    children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            renderComponent: faq.renderComponent,
                            question: faq.question,
                            answer: faq.answer,
                            anchor: faq.anchor,
                            active: faq.active
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Faqs);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 54239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.tsx
var Faqs = __webpack_require__(29372);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.styled.tsx
var Faqs_styled = __webpack_require__(12109);
;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyComponent.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      padding-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: ",
        " ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f83121f-0"
})(_templateObject(), Faqs_styled/* StyledFaqsSection */.s5, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"));
var StyledFaqsActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f83121f-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));

// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyData.styled.ts

function PrivacyPolicyData_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        ";\n\n  ",
        " {\n    text-align: center;\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: 0;\n  }\n"
    ]);
    PrivacyPolicyData_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrivacyPolicyData_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"
    ]);
    PrivacyPolicyData_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 20rem;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    max-width: unset;\n  }\n\n  p {\n    margin: 0;\n    line-height: 1.5;\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 5rem;\n  height: 5rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  padding-top: ",
        ";\n  margin-top: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var PrivacyPolicyData_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f6dc29-0"
})(PrivacyPolicyData_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("lg"), Faqs_styled/* StyledFaqsSection */.s5, (0,theme/* spacing */.W0)("xl4"));
var StyledCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f6dc29-1"
})(PrivacyPolicyData_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f6dc29-2"
})(_templateObject2(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledCardIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-79f6dc29-3"
})(_templateObject3());
var StyledCardSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-79f6dc29-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("cyan_700"));
var StyledCardTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-79f6dc29-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledCardLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-79f6dc29-6"
})(_templateObject6(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyData.tsx











var PrivacyPolicyData = function() {
    var t = (0,useI18n/* useI18n */.Q)("privacyPolicy").t;
    var locale = (0,router.useRouter)().locale;
    var dataCard = [
        {
            icon: (0,paths/* getPublicPath */.A)("/images/icons/cookies.svg"),
            title: t("data.dataCards.cardCookies.title"),
            text: t("data.dataCards.cardCookies.text"),
            link: t("data.dataCards.cardCookies.textLink"),
            linkHref: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.cookies */.uu.cookies, locale)
        },
        {
            icon: (0,paths/* getPublicPath */.A)("/images/icons/usage-data.svg"),
            title: t("data.dataCards.cardUsarage.title"),
            text: t("data.dataCards.cardUsarage.text"),
            link: t("data.dataCards.cardUsarage.textLink"),
            linkHref: "#dataTools"
        },
        {
            icon: (0,paths/* getPublicPath */.A)("/images/icons/consent.svg"),
            title: t("data.dataCards.freely.title"),
            text: t("data.dataCards.freely.text"),
            link: t("data.dataCards.freely.textLink"),
            linkHref: "#",
            tooltip: t("data.dataCards.freely.toolTip")
        }
    ];
    var dataFaqs = [
        {
            question: t("data.faqs.faq1.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "privacyPolicy",
                i18nKey: "data.faqs.faq1.answer",
                components: {
                    privacyGoogle: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.google.com/intl/en/policies/privacy/",
                        target: "-blank"
                    }),
                    privacyAnalytics: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://tools.google.com/dlpage/gaoptout",
                        target: "-blank"
                    })
                }
            }),
            renderComponent: true
        },
        {
            question: t("data.faqs.faq2.question"),
            answer: t("data.faqs.faq2.answer")
        },
        {
            question: t("data.faqs.faq3.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "privacyPolicy",
                i18nKey: "data.faqs.faq3.answer",
                components: {
                    privacyGoogle: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.google.com/intl/en/policies/privacy/",
                        target: "_blank",
                        rel: "noreferrer"
                    }),
                    privacyAnalytics: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://tools.google.com/dlpage/gaoptout",
                        target: "_blank",
                        rel: "noreferrer"
                    }),
                    mail: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:team@getmanfred.com"
                    })
                }
            }),
            renderComponent: true
        },
        {
            question: t("data.faqs.faq4.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "privacyPolicy",
                i18nKey: "data.faqs.faq4.answer",
                components: {
                    privacyGoogle: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.google.com/intl/en/policies/privacy/",
                        target: "-blank"
                    }),
                    privacyAnalytics: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://tools.google.com/dlpage/gaoptout",
                        target: "_blank",
                        rel: "noreferrer"
                    })
                }
            }),
            renderComponent: true
        },
        {
            question: t("data.faqs.faq5.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "privacyPolicy",
                i18nKey: "data.faqs.faq5.answer",
                components: {
                    manfredDaily: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.manfredDaily */.uu.manfredDaily, locale)
                    }),
                    mailchimpPrivacy: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://telegram.org/privacy"
                    }),
                    telegramPrivacy: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://telegram.org/privacy"
                    })
                }
            }),
            renderComponent: true
        },
        {
            question: t("data.faqs.faq6.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "privacyPolicy",
                i18nKey: "data.faqs.faq6.answer",
                components: {
                    privacyDigitalOcean: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.digitalocean.com/legal/privacy-policy"
                    })
                }
            }),
            renderComponent: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrivacyPolicyData_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("data.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCards, {
                children: dataCard.map(function(c, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardIcon, {
                                src: c.icon,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardSeparator, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardTitle, {
                                children: c.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: c.text
                                }
                            }),
                            !c.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardLink, {
                                href: c.linkHref,
                                children: c.link
                            }),
                            c.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                content: c.tooltip,
                                direction: "down",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardLink, {
                                    href: "#",
                                    onClick: function(e) {
                                        return e.preventDefault();
                                    },
                                    children: c.link
                                })
                            })
                        ]
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "dataTools",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                    faqs: dataFaqs,
                    h3: true,
                    title: t("data.faqs.title")
                })
            })
        ]
    });
};
/* harmony default export */ var privacyPolicy_PrivacyPolicyData = (PrivacyPolicyData);

// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyDetails.styled.ts

function PrivacyPolicyDetails_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    PrivacyPolicyDetails_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrivacyPolicyDetails_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    font-size: ",
        ";\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n\n    &::before {\n      left: 0;\n      transform: unset;\n    }\n  }\n\n  p {\n    margin: 0;\n  }\n\n  a {\n    font-weight: ",
        ";\n  }\n\n  img {\n    max-width: 25.5rem;\n    display: block;\n  }\n"
    ]);
    PrivacyPolicyDetails_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b59593d9-0"
})(PrivacyPolicyDetails_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"));
var PrivacyPolicyDetails_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b59593d9-1"
})(PrivacyPolicyDetails_styled_templateObject1(), (0,theme/* color */.$_)("white"), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* fontSize */.JB)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyDetails.tsx









var PrivacyPolicyDetails = function() {
    var t = (0,useI18n/* useI18n */.Q)("privacyPolicy").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrivacyPolicyDetails_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            editorial: true,
                            children: t("details.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                ns: "privacyPolicy",
                                i18nKey: "details.desc",
                                components: {
                                    mail: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:hello@getmanfred.com",
                                        children: "hello@getmanfred.com"
                                    }),
                                    team: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.team */.uu.team, locale)
                                    })
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/details-img.png"),
                    alt: ""
                })
            ]
        })
    });
};
/* harmony default export */ var privacyPolicy_PrivacyPolicyDetails = (PrivacyPolicyDetails);

// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyFeatures.styled.ts

function PrivacyPolicyFeatures_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    PrivacyPolicyFeatures_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrivacyPolicyFeatures_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: 0 auto ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n\n  ",
        " {\n    margin-top: 0.3em;\n    margin-bottom: ",
        ";\n\n    &::before {\n      left: 0;\n      transform: unset;\n    }\n  }\n\n  p {\n    line-height: 1.5;\n\n    &:first-of-type {\n      margin-top: 0;\n    }\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  img {\n    display: block;\n    max-width: 20rem;\n  }\n"
    ]);
    PrivacyPolicyFeatures_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PrivacyPolicyFeatures_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1b3b26e-0"
})(PrivacyPolicyFeatures_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"));
var StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1b3b26e-1"
})(PrivacyPolicyFeatures_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), Typography_styled/* Heading2 */.XJ, (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyFeatures.tsx





var PrivacyPolicyFeatures = function() {
    var t = (0,useI18n/* useI18n */.Q)("privacyPolicy").t;
    var features = [
        {
            image: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/feature01.svg"),
            title: t("policyFeatures.features.feature1.title"),
            text: t("policyFeatures.features.feature1.text")
        },
        {
            image: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/feature02.svg"),
            title: t("policyFeatures.features.feature2.title"),
            text: t("policyFeatures.features.feature2.text")
        },
        {
            image: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/feature03.svg"),
            title: t("policyFeatures.features.feature3.title"),
            text: t("policyFeatures.features.feature3.text")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicyFeatures_styled_StyledContainer, {
        children: features.map(function(f, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: f.image,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                                editorial: true,
                                children: f.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: f.text
                                }
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ var privacyPolicy_PrivacyPolicyFeatures = (PrivacyPolicyFeatures);

;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyHero.styled.ts

function PrivacyPolicyHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    PrivacyPolicyHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrivacyPolicyHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    padding-left: 0;\n    padding-right: 0;\n  }\n"
    ]);
    PrivacyPolicyHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PrivacyPolicyHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: left bottom;\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-position: center bottom;\n  }\n\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: ",
        ";\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    text-align: center;\n\n    @media (min-width: ",
        ") {\n      flex-direction: row;\n      align-items: flex-start;\n      text-align: left;\n    }\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.14;\n    font-weight: ",
        ";\n    margin: 0;\n\n    @media (max-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    PrivacyPolicyHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PrivacyPolicyHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 18rem;\n  margin-top: -5%;\n  margin-bottom: -5%;\n  aspect-ratio: 6 / 5;\n\n  @supports not (aspect-ratio: 6 / 5) {\n    @media (max-width: ",
        ") {\n      height: 15rem;\n    }\n  }\n\n  img {\n    position: absolute;\n    inset: 0;\n  }\n"
    ]);
    PrivacyPolicyHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PrivacyPolicyHero_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  text-align: center;\n  font-size: ",
        ";\n  line-height: 1.6;\n\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    &::before {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    PrivacyPolicyHero_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PrivacyPolicyHero_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.16;\n  font-weight: ",
        ";\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    PrivacyPolicyHero_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PrivacyPolicyHero_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 3.5rem 2.5rem 2.5rem;\n  border-radius: ",
        ";\n\n  @media (max-width: ",
        ") {\n    padding: 2.5rem 1.25rem 1.25rem;\n  }\n\n  ",
        " {\n    text-align: center;\n    margin-bottom: ",
        ";\n    &::before {\n      background-color: ",
        ";\n    }\n  }\n\n  li {\n    padding-left: 2rem;\n    margin-bottom: ",
        ";\n    position: relative;\n    font-weight: ",
        ";\n    line-height: 1.25;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      width: 1.25rem;\n      height: 1.25rem;\n      background-image: url(\"data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fal' data-icon='check-circle' class='svg-inline--fa fa-check-circle fa-w-16 ' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='24px' height='24px'%3E%3Cpath fill='%23C0BEC9' d='M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z'%3E%3C/path%3E%3C/svg%3E%0A\");\n      background-size: contain;\n      background-repeat: no-repeat;\n      margin-right: ",
        ";\n      margin-top: 0.1em;\n    }\n  }\n\n  strong {\n    font-weight: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:active {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    PrivacyPolicyHero_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ad0abc1-0"
})(PrivacyPolicyHero_styled_templateObject(), (0,theme/* color */.$_)("navy_700"), (0,theme/* color */.$_)("text_default_inverse"));
var PrivacyPolicyHero_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ad0abc1-1"
})(PrivacyPolicyHero_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("lg"));
var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-6ad0abc1-2"
})(PrivacyPolicyHero_styled_templateObject2(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/privacyPolicy/hero-bg.svg"), "')");
}, (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), PrivacyPolicyHero_styled_StyledContainer, (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), Typography/* Heading1 */.nL, (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* fontSize */.JB)("lg"));
var StyledImageComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ad0abc1-3"
})(PrivacyPolicyHero_styled_templateObject3(), (0,theme/* screen */.sp)("mdMax"));
var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ad0abc1-4"
})(PrivacyPolicyHero_styled_templateObject4(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* fontSize */.JB)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("sun_900"));
var StyledLead = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-6ad0abc1-5"
})(PrivacyPolicyHero_styled_templateObject5(), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* fontSize */.JB)("md"));
var StyledRights = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ad0abc1-6"
})(PrivacyPolicyHero_styled_templateObject6(), (0,theme/* color */.$_)("navy_800"), (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("mdMax"), Typography/* Heading3 */.aC, (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("sun_900"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"));

;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyHero.tsx
//import { LinkText } from 'components/shared/LinkText';






var PrivacyPolicyHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("privacyPolicy").t;
    var rights = [
        t("hero.userRights.rights.right1"),
        t("hero.userRights.rights.right2"),
        t("hero.userRights.rights.right3"),
        t("hero.userRights.rights.right4"),
        t("hero.userRights.rights.right5"),
        t("hero.userRights.rights.right6"),
        t("hero.userRights.rights.right7"),
        t("hero.userRights.rights.right8")
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrivacyPolicyHero_styled_StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading1 */.nL, {
                                    children: t("title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("subtitle")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImageComp, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/r2.svg"),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/luces.svg"),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/privacyPolicy/holograma.svg"),
                                    alt: ""
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrivacyPolicyHero_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIntro, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                                editorial: true,
                                children: t("hero.compromise.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    ns: "privacyPolicy",
                                    i18nKey: "hero.compromise.desc",
                                    components: {
                                        strong: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {})
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIntro, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                                editorial: true,
                                children: t("hero.european.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLead, {
                                children: t("hero.european.subtitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("hero.european.desc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRights, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                editorial: true,
                                children: t("hero.userRights.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: rights.map(function(r, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        dangerouslySetInnerHTML: {
                                            __html: r
                                        }
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var privacyPolicy_PrivacyPolicyHero = (PrivacyPolicyHero);

;// CONCATENATED MODULE: ./components/marketingSite/privacyPolicy/PrivacyPolicyComponent.tsx













var PrivacyPolicyComponent = function() {
    var t = (0,useI18n/* useI18n */.Q)("privacyPolicy").t;
    var glossary = [
        {
            question: t("glosary.glosary1.question"),
            answer: t("glosary.glosary1.answer")
        },
        {
            question: t("glosary.glosary2.question"),
            answer: t("glosary.glosary2.answer")
        },
        {
            question: t("glosary.glosary3.question"),
            answer: t("glosary.glosary3.answer")
        },
        {
            question: t("glosary.glosary4.question"),
            answer: t("glosary.glosary4.answer")
        },
        {
            question: t("glosary.glosary5.question"),
            answer: t("glosary.glosary5.answer")
        },
        {
            question: t("glosary.glosary6.question"),
            answer: t("glosary.glosary6.answer")
        },
        {
            question: t("glosary.glosary7.question"),
            answer: t("glosary.glosary7.answer")
        },
        {
            question: t("glosary.glosary8.question"),
            answer: t("glosary.glosary8.answer")
        },
        {
            question: t("glosary.glosary9.question"),
            answer: t("glosary.glosary9.answer")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy_PrivacyPolicyHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy_PrivacyPolicyData, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy_PrivacyPolicyFeatures, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                    faqs: glossary,
                    title: t("glosary.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFaqsActions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                            href: "https://drive.google.com/file/d/17WOXPUgKnF7Dfs6f2PMoV2udmcFi2Kys/view",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCloudDownload */._mg
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("glosary.CTA.download")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                            href: "https://github.com/getmanfred/privacy-policy",
                            variant: "secondary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_brands_svg_icons/* faGithub */.zhw
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("glosary.CTA.github")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy_PrivacyPolicyDetails, {})
            ]
        })
    });
};
/* harmony default export */ var privacyPolicy_PrivacyPolicyComponent = (PrivacyPolicyComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/privacy-policy.tsx






var PrivacyPolicyPage = function() {
    var t = (0,useI18n/* useI18n */.Q)("privacyPolicy").t;
    (0,usePageTrack/* usePageTrack */.N)("Website - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                url: app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy,
                title: t("title"),
                desc: t("description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy_PrivacyPolicyComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var privacy_policy = (PrivacyPolicyPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,7265,9774,2888,179], function() { return __webpack_exec__(65399); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);